module.exports = __webpack_public_path__ + "static/img/18.b1d76f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/18.png
// module id = ecF7
// module chunks = 1